import { h } from 'preact';
import { getLabel } from "../../../../labels/labelling-service";
import Cta from '../../../components/2-atoms/cta/cta';
import SkyItBox from '../../../components/3-molecules/sky-it-box/sky-it-box';
import { IconArrowLink } from '../../../components/1-foundation/icons/icons';
import { useEffect } from 'preact/hooks';
import { premiumBFF } from '../../../../utils/premium-utils';
import { getSiteName } from '../../../../utils/aem-utils';
import logger from '../../../../services/logging/logging-service';

export const renderPremium = ({ pageState: { premiumStatus }, pageActions, premiumWidgetConfig }) => {
    const { isLoading, isError, payload = null } = premiumStatus;
    const { setPremiumStatus } = pageActions;

    useEffect(() => {
        (async () => {
            try {
                const response = await premiumBFF.fetchUserSubscription(getSiteName(), { returnURL: location.href })
                if (response.redirectTo) location.href = response.redirectTo;
                setPremiumStatus({
                    isLoading: false,
                    isError: false,
                    ...response
                });
            }
            catch (err) {
                setPremiumStatus({
                    isLoading: false,
                    isError: true,
                })
            }
        })()
    }, [])

    if (isLoading || isError) return null;

    const { user: { type: userType }, subscription: { status, payload: { cta } } } = payload;

    const { title, description } = premiumWidgetConfig.products[getSiteName()][status][userType];

    const ctaModifiers = status == 'active' ? ['sky-it-primary'] : ['sky-it-primary', 'editorial-premium'];

    const ctaProps = {
        href: cta.url,
        modifiers: ctaModifiers,
        append: status == 'active' ? <IconArrowLink modifiers={['arrow-navigation', 'arrow-link', 'c-light']} /> : null,
    };

    return (
        <SkyItBox
            title={title}
            description={description}
        >
            <div className="c-sky-it-box__footer-premium">
                <Cta {...ctaProps}>
                    {cta.label}
                </Cta>
            </div>
        </SkyItBox>
    );
};
